export default __webpack_public_path__ + "static/media/driedFruit.1943e8e8.jpg";